import { render, staticRenderFns } from "./FrenchWindowLockDamage.vue?vue&type=template&id=66fa84b8&scoped=true"
import script from "./FrenchWindowLockDamage.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa84b8",
  null
  
)

export default component.exports